module.exports = __webpack_public_path__ + "img/img1.097256df.png";